import api from '@/lib/api'
import { useAccessToken, useClearAuthState } from '../state/auth'
import { clearAuthStorage } from '../utils/auth-storage'

export default function useSignOut() {
  const clearAuth = useClearAuthState()
  const token = useAccessToken()
  const signOut = async () => {
    try {
      if (!token) {
        throw new Error('Token não encontrado')
      }

      await api.post('/auth/logout', null, {
        headers: { Authorization: `Bearer ${token}` }
      })

      clearAuth()
      clearAuthStorage()
      window.location.href = '/signin'
    } catch (error) {
      console.error('Erro ao fazer logout:', error)
      throw new Error('Erro ao fazer logout')
    }
  }

  return { signOut }
}
